export default __webpack_public_path__ + "static/media/dashboard-wireframe.458abf2d.png";